import {authServerInstance} from "../axiosInstance";
export const getGlobalCustomerFilterList = async (userId) => {
    try {
        // return await gatewayInstance.get(`${SERVICE_ENDPOINT.AUTHENTICATION}/user-customer-filteration/user/${userId}`);
        return await authServerInstance.get(`/user-customer-filteration/user/${userId}`);
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export const createGlobalCustomerFilter = async (user, data) => {
    try {
        // backend usually accepts either a single object or an array
        // return await gatewayInstance.post(`{${SERVICE_ENDPOINT.AUTHENTICATION}/user-customer-filteration/create`, data);
        return await authServerInstance.post(`/user-customer-filteration/create/${user}`, data);
    } catch (error) {
        console.error(error);
        throw error;
    }
};